import React from 'react';
export function DoctorConsultation() {
  return <div className="bg-gradient-to-br from-[#0072ff] to-[#00c6ff] rounded-2xl shadow-[0_4px_12px_rgba(0,0,0,0.1)] overflow-hidden h-full relative" data-id="element-5263" data-mp="11jl0hbpkucbe">
      <div className="absolute inset-0 opacity-10" data-id="element-5264" data-mp="2vcqy8hcaixsb">
        <div className="absolute inset-0" style={{
        backgroundImage: 'url(\'data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="1"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\')'
      }} data-id="element-5265" data-mp="2ve236khh2bl0"></div>
      </div>
      <div className="relative z-10 p-6 md:p-10 text-center h-full flex flex-col justify-center" data-id="element-5266" data-mp="3j8wfx2rz9drc">
        <span className="inline-block bg-white text-[#0072ff] text-xs font-bold px-3 md:px-4 py-1 md:py-1.5 rounded-full mb-3 md:mb-4 mx-auto" data-id="element-5267" data-mp="at3616s5j0j9">
          HEALTHCARE SERVICES
        </span>
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-2 md:mb-3" data-id="element-5268" data-mp="t5kk6e3lxzyr">
          Doctor Consultation
        </h2>
        <p className="text-blue-100 text-sm md:text-lg max-w-xl mx-auto mb-4 md:mb-6 leading-relaxed" data-id="element-5269" data-mp="p6btji3v6i7f">
          Get expert medical advice from licensed healthcare professionals from
          the comfort of your home
        </p>
        <div className="flex items-center justify-center gap-2 mb-4 md:mb-6" data-id="element-5270" data-mp="y3m3n04y41ar">
          <div className="bg-white bg-opacity-25 backdrop-blur-sm rounded-full px-4 md:px-5 py-2 md:py-2.5 text-white font-medium" data-id="element-5271" data-mp="1csic2yawzgbw">
            <span className="text-xl md:text-2xl font-bold" data-id="element-5272" data-mp="1lv1exiep9sy5">24/7</span>{' '}
            Available
          </div>
        </div>
        <button className="bg-[#FFD700] hover:bg-[#E6C200] text-[#1E2B55] font-bold py-3 md:py-3.5 px-8 md:px-10 rounded-lg transition-all shadow-lg hover:shadow-xl transform hover:scale-105 mx-auto text-sm md:text-base" data-id="element-5273" data-mp="1gvoravg08hui">
          Talk Now
        </button>
      </div>
    </div>;
}